export default ".spinner {\n  display: flex;\n  justify-content: center;\n  font-size: 0.8rem;\n  margin-top: 1rem;\n}";